/** Hosted product apps live at /a/<app>/ on this origin but are served by the backend, not
 * the portal router (WST-892). A `next` pointing there needs a full navigation. The pattern
 * is anchored to a single-slash path, so protocol-relative and absolute URLs never match. */
const HOSTED_APP_RE = /^\/a\/[a-z0-9-]+\/(?:[^/].*)?$/;

export function isHostedAppPath(next: string | null | undefined): boolean {
  return !!next && HOSTED_APP_RE.test(next);
}

export function goToNext(
  next: string | null | undefined,
  navigate: (to: string) => void,
  assign: (url: string) => void = (url) => window.location.assign(url),
): void {
  if (isHostedAppPath(next)) {
    assign(next as string);
    return;
  }
  navigate(next || '/home');
}
